var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigalTimesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9016_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.836 12.9868C46.8923 16.5354 37.3036 17.0195 32.0718 15.7271C23.5889 13.6397 15.6834 6.99997 17.7975 1.24406C18.4814 0.551221 20.4711 0.315832 21.1107 0.711107C18.8811 8.77204 35.1585 15.8914 42.491 12.0053C42.7309 11.8765 43.0417 11.6811 43.2638 11.5256C43.9833 11.5478 44.7561 12.8358 44.8405 12.9824",
    fill: "url(#paint0_linear_9016_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5718 44.6798C34.1193 51.284 4.38935 43.9958 0.889613 28.9443C0.74305 28.1404 0.543192 27.0701 0.436602 26.2618L0.290039 24.4364C1.91555 39.0616 27.3819 49.0989 41.7272 43.907C41.8205 43.8848 41.9449 43.8581 42.0381 43.8359C42.047 43.9292 42.0559 44.0536 42.0648 44.1513C41.9227 44.3156 41.7361 44.5377 41.5718 44.6842",
    fill: "url(#paint1_linear_9016_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0694 19.2224C49.384 23.6103 34.6034 26.1996 21.6526 19.0403C21.4483 18.9248 21.1774 18.7649 20.9731 18.6494C19.6096 17.8011 17.3312 16.3755 15.2083 14.1859C11.5842 10.1755 10.4872 6.83561 11.6508 3.3492C12.2859 2.46094 13.7738 1.74145 14.5465 1.94575C14.0491 4.0598 13.3696 6.95552 17.7354 11.7343C18.6459 12.6226 20.1692 14.106 22.8473 15.6915C32.9823 21.3675 42.3446 20.7279 46.7592 17.7256C47.5542 17.6324 47.9939 18.9559 48.0738 19.2224",
    fill: "url(#paint2_linear_9016_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.179 25.3957C50.3566 28.2737 43.5126 31.6757 32.7913 30.2545C30.8416 29.9303 27.5773 29.384 23.4913 27.794C8.86168 21.705 3.9585 12.2451 6.76539 6.44033C7.35164 5.5121 8.22658 4.68158 8.99492 4.32184C9.03045 4.38402 9.07486 4.47284 9.10595 4.53502C5.97929 12.3162 14.8308 20.6347 24.7437 24.5075C26.5202 25.1559 29.4959 26.244 33.4398 26.8081C36.3222 27.1412 43.9745 28.0294 49.233 23.9834C49.3129 23.9612 49.4239 23.9301 49.5039 23.9079C49.7304 24.0589 50.1123 24.3165 50.179 25.3957Z",
    fill: "url(#paint3_linear_9016_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2101 31.8401C49.4063 35.6729 38.4452 39.9587 23.6734 35.1977C21.6615 34.496 18.2906 33.3235 14.4755 31.0451C-0.225115 21.7761 2.05771 13.6042 3.11029 11.3169L3.27906 10.9838L4.11846 9.50041C4.28723 9.22505 4.46636 8.95117 4.65586 8.67877C1.85785 17.3437 9.16821 23.9612 15.7902 27.985C17.5445 28.9799 20.4757 30.6409 24.7527 32.0311C39.9019 36.5656 47.2611 32.5018 49.7216 30.5432C49.8015 30.5121 49.9081 30.4722 49.9881 30.4411C50.1524 30.5699 50.4322 30.7831 50.2101 31.8445",
    fill: "url(#paint4_linear_9016_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4833 48.4505C28.5631 50.791 12.3791 48.5437 4.76226 37.9957C4.42028 37.4494 3.95839 36.7299 3.64306 36.1703C3.24778 35.3975 2.72371 34.3671 2.36841 33.5721C7.06285 43.2231 22.1721 49.9916 34.701 48.0596C34.8209 48.0419 34.9808 48.0374 35.1007 48.0419C35.003 48.2284 34.9897 48.2462 34.4833 48.4505Z",
    fill: "url(#paint5_linear_9016_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8963 38.2355C45.1382 43.1698 29.2784 46.5096 12.6858 36.9564C10.9759 35.8905 8.12013 34.1096 5.45979 31.3604C3.91423 29.6505 -0.193962 25.1071 0.476672 19.8441C0.943007 17.1172 0.960772 17.0106 1.43599 15.4473C1.02295 17.2238 -0.0829299 21.936 6.18372 28.5402C7.48946 29.8104 9.67013 31.9378 13.5118 34.2161C28.0659 42.3748 41.5364 41.451 47.8963 37.1341C47.9718 37.103 48.0784 37.0586 48.1539 37.023C48.2738 37.2895 48.3404 37.4361 47.8963 38.2311",
    fill: "url(#paint6_linear_9016_5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9016_5",
    x1: 17.4511,
    y1: 8.45227,
    x2: 45.1247,
    y2: 8.45227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E37F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87F2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9016_5",
    x1: 0.290039,
    y1: 35.7839,
    x2: 42.0648,
    y2: 35.7839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E37F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87F2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9016_5",
    x1: 11.2023,
    y1: 12.707,
    x2: 48.1493,
    y2: 12.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E37F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87F2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9016_5",
    x1: 6.01038,
    y1: 17.4547,
    x2: 50.1834,
    y2: 17.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E37F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87F2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9016_5",
    x1: 2.31974,
    y1: 22.9886,
    x2: 50.2901,
    y2: 22.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E37F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87F2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9016_5",
    x1: 2.37285,
    y1: 41.4332,
    x2: 35.1007,
    y2: 41.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E37F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87F2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9016_5",
    x1: 0.410052,
    y1: 29.2508,
    x2: 48.2471,
    y2: 29.2508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E37F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87F2E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9016_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigalTimesLogo);
export default __webpack_public_path__ + "static/media/LigalTimesLogo.907f71da7628d2180122ed6e8a2293aa.svg";
export { ForwardRef as ReactComponent };